import { useEffect, useState } from "react";
import "./index.css";
import BookingDetailCard from "./Components/BookingDetailCard";
import { E_TICKET_API, GET_BOOKING_DETAILS_BY_ID_API, UPDATE_BOOKING_API } from "../../APIs";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const BookingConfirmation = () => {
    const [bookingData, setBookingData] = useState({});
    const { id } = useParams();
    const [ticketLoader, setTicketLoader] = useState(false)
    const [updateBookingLoader, setUpdateBookingLoader] = useState(false)

    useEffect(() => {
        if (id) {
            fetchBookingDetails(id);
        }
    }, [id]);


    const handleDownloadE_Tickets = async () => {
        const toastId = toast.loading("Checking e-ticket downloads...");

        try {
            setTicketLoader(true);
            const payload = { trp_booking_id: bookingData?.id };
            const response = await E_TICKET_API(payload);

            if (response && response?.status) {
                let hasValidLinks = false;

                response?.data?.forEach((ticket) => {
                    if (!ticket.error.status && ticket.DownloadLink) {
                        hasValidLinks = true;
                        window.open(ticket.DownloadLink, "_blank");
                    } else {
                        console.warn(`Skipping ticket: ${ticket.error.message}`);
                    }
                });

                if (hasValidLinks) {
                    toast.update(toastId, {
                        render: "Downloading available e-tickets...",
                        type: "success",
                        isLoading: false,
                        autoClose: 3000,
                    });
                } else {
                    toast.update(toastId, {
                        render: "No downloadable e-tickets available.",
                        type: "warning",
                        isLoading: false,
                        autoClose: 3000,
                    });
                }
            } else {
                throw new Error("Invalid response format.");
            }
        } catch (error) {
            console.error(error);
            toast.update(toastId, {
                render: "Failed to retrieve e-tickets. Please try again.",
                type: "error",
                isLoading: false,
                autoClose: 3000,
            });
        } finally {
            setTicketLoader(false);
        }
    };


    const updateBookingApi = async () => {
        setUpdateBookingLoader(true)
        try {
            const response = await UPDATE_BOOKING_API(bookingData?.id)
            if (response?.status) {
                toast.success(response?.message)
                fetchBookingDetails(id)
            } else {
                toast.error(response?.message)
            }
        } catch (error) {
            console.log(error, "UPDATE_BOOKING_API")
        }
        finally {
            setUpdateBookingLoader(false)
        }
    }



    const fetchBookingDetails = async (id) => {
        try {
            const response = await GET_BOOKING_DETAILS_BY_ID_API(id);
            if (response && response?.status) {
                setBookingData(response?.data);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.log(error, "BOOKING_DETAILS");
        }
    };

    return (
        <div className="Events_booking_page">
            <div className="events_container" id="confirm_booking_container">
                <div className="confirmation-page">
                    <div className="confirmation-header" >
                        {/* {currentStatus.icon} */}
                        <h1>Thank You for Your Booking!</h1>
                        <p>
                            Booking Status <span style={{ textTransform: "uppercase", color: "orange" }}>{bookingData?.trp_booking_status || "N/A"}</span>
                        </p>
                    </div>
                    <BookingDetailCard booking={bookingData} handleDownloadE_Tickets={handleDownloadE_Tickets} updateBookingApi={updateBookingApi} updateBookingLoader={updateBookingLoader} />

                </div>
            </div>
        </div>
    );
};

export default BookingConfirmation;
